//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            show_list: false
        }
    },
    props: {
        value: [String, Number],
        range: [Array],
        value: [String, Number],
        'range-key': String
    },
    watch: {
        value: {
            handler (val, old) {
                if (val != old) {
                    this.$nextTick(this.moveScroll)
                }
            },
            immediate: true
        }
    },
    computed: {
        list () {
            if (this.range && this.range.length) {
                const key = this.rangeKey
                return this.range.map((item) => {
                    return key ? item[key] : item
                })
            }
        }
    },
    methods: {
        moveScroll () {
            if (this.$el && typeof this.$el.querySelector === 'function') {
                const $active_el = this.$el.querySelector('.active')
                if ($active_el) {
                    $active_el.scrollIntoView()
                }
            }
            console.log(this.$el)
        },
        select (i) {
            this.$emit('change', {
                target: {
                    value: i
                }
            })
        },
        toggleList () {
            this.show_list = !this.show_list
        }
    }
}
